import angular from 'angular';
import livingExpense from './livingExpense';
import otherExpenseForm from './otherExpenseForm/otherExpenseForm';

export default angular
  .module('components.livingExpense', [])
  .component('livingExpense', livingExpense)
  .component('otherExpenseForm', otherExpenseForm).name;
